import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const [click, setClick] = useState(false);
    
    const handleClick = () => {
        setClick(!click);
    }
    const closeMobileMenu = () => setClick(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    
    useEffect(() => {
        const handleResize = () => {
            // Close mobile menu on desktop resize
            // 880 must match the mobile breakpoint in Navbar.css
            if (window.innerWidth > 880) {
                setClick(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Lock page scroll while the mobile menu is open
    useEffect(() => {
        if (click) {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = scrollbarWidth + 'px';
        } else {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
        return () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, [click]);

    return (
        <>
            <nav className='navbar'>
                <div className='navbar-container'>
                    <Link to='/' className='nav-logo' onClick={() => { scrollToTop(); closeMobileMenu(); }}>
                        <img src='/images/rapid_logo.png' className='rapid-logo' alt=""/>
                    </Link>
                    <div className='menu-icon' onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className='nav-item'>
                            <Link to='/modelling' className='nav-links' onClick={() => { scrollToTop(); closeMobileMenu(); }}>
                                MODELLING SERVICE
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/exotic_materials' className='nav-links' onClick={() => { scrollToTop(); closeMobileMenu(); }}>
                                EXOTIC MATERIALS
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/filament_recycler' className='nav-links' onClick={() => { scrollToTop(); closeMobileMenu(); }}>
                                FILAMENT RECYCLER
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/projects' className='nav-links' onClick={() => { scrollToTop(); closeMobileMenu(); }}>
                               ADVANCEMENTS
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/join-us' className='nav-links' onClick={() => { scrollToTop(); closeMobileMenu(); }}>
                                JOIN US
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    );
}

export default Navbar;